import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiVisa, Core2Config } from "../../shared";

@Injectable({ providedIn: "root" })
export class BotCfAutomationService {
  private apiUrl: string;
	private endpointPath: string;

	constructor(private httpClient:HttpClient) {
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_BOT_MODULE + 'bot-cf-automation';
    this.endpointPath = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_BOT_MODULE + 'bot-cf-automation';
  }

	public getHttpHeader(apiVisa: ApiVisa): HttpHeaders {
		// Fallback for undefined values
		apiVisa.applet_code = apiVisa.applet_code || 'none';
		apiVisa.tenantCode = apiVisa.tenantCode || '';
	
		return new HttpHeaders({
			Authorization: apiVisa.jwt_secret, // Use "Authorization" as standard
			tenantCode: apiVisa.tenantCode,    // Include if necessary, remove if not needed
			appId: apiVisa.applet_code         // Include if necessary, remove if not needed
		});
	}
	
	botHandOver(data:any, visa: ApiVisa){
		let url = this.apiUrl + '/bot-handover';
		if (this.endpointPath && visa.api_domain_url) {
			url = visa.api_domain_url + this.endpointPath + '/bot-handover';
		}
		  // Add query parameters to the URL
			let params = new HttpParams()
			.set('conversationUuid', data['conversationUuid'])
			.set('loginSubjectGuid', data['loginSubjectGuid'])
			.set('conversationTitle', data['conversationTitle'])
			.set('userId', data['userId'])	
			.set('targetType', data['targetType'])	
			.set('channel', data['channel'])	
			.set('virtualId', data['virtualId'])	

		return this.httpClient.get(url, { headers: this.getHttpHeader(visa), params:params });
	}
}